// Casilla "Avisar al cliente" al resolver un caso (D90). Hay correos que nunca reciben el aviso de caso cerrado: los
// nuestros (caso interno) y los de robots, que contestarian solos y armarian un bucle de correos. Mismas reglas que
// noSeLeResponde en la app (src/lib/respuestas.ts), mas los buzones y dominios propios de la empresa.
export const ROBOT = /(no-?reply|do-?not-?reply|mailer-daemon|postmaster|bounce|notification|notificaciones|alert|autorespond|auto-?reply)/i;
const SIN_RESPUESTA = /(@xmartek\.com$|@patton\.com$|^helpdesk@3cx\.com$|@3cx\.net$)/i;
// Dominios de correo publico: que un buzon nuestro sea de gmail no vuelve internos a todos los de gmail.
const PUBLICOS = new Set(['gmail.com', 'googlemail.com', 'hotmail.com', 'outlook.com', 'live.com', 'yahoo.com', 'icloud.com', 'msn.com', 'aol.com', 'proton.me', 'protonmail.com']);

const dominio = (correo: string) => correo.toLowerCase().split('@')[1]?.trim() ?? '';

export function nuncaSeAvisa(correo: string | null | undefined, mios: string[]): boolean {
  const c = (correo ?? '').trim().toLowerCase();
  if (!c || ROBOT.test(c) || SIN_RESPUESTA.test(c)) return true;
  if (mios.some((m) => m.toLowerCase() === c)) return true;
  const internos = new Set(mios.map(dominio).filter((x) => x && !PUBLICOS.has(x)));
  return internos.has(dominio(c));
}
